// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/expert_card.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Badge } from "../../../../enums/gig/badge";
import { SellerLevel } from "../../../../enums/listing/seller_level";
import { HighlightType } from "../../../../enums/expert_card/highlight_type";
import { ExpertiseType } from "../../../../enums/expert_card/expertise_type";
import { Gig } from "../../../../entities/gig";
import { Seller } from "../../../../entities/seller";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard
 */
export interface ExpertCard {
    /**
     * Expert card data
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes expert_card_attributes = 1
     */
    expertCardAttributes?: ExpertCard_ExpertCardAttributes;
    /**
     * @generated from protobuf field: bianka.entities.Seller seller = 2
     */
    seller?: Seller;
    /**
     * @generated from protobuf field: bianka.entities.Gig gig = 3
     */
    gig?: Gig;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes
 */
export interface ExpertCard_ExpertCardAttributes {
    /**
     * The shown rating of the seller
     *
     * @generated from protobuf field: double shown_seller_rating = 1
     */
    shownSellerRating: number;
    /**
     * The number of seller's completed orders
     *
     * @generated from protobuf field: int32 completed_orders = 2
     */
    completedOrders: number;
    /**
     * Indicates if the gig's seller is online
     *
     * @generated from protobuf field: bool is_online = 3
     */
    isOnline: boolean;
    /**
     * Seller's expertise
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise expertise = 5
     */
    expertise: ExpertCard_ExpertCardAttributes_Expertise[];
    /**
     * Card's highlights
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight highlights = 6
     */
    highlights: ExpertCard_ExpertCardAttributes_Highlight[];
    /**
     * Seller's details
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller seller = 7
     */
    seller?: ExpertCard_ExpertCardAttributes_Seller;
    /**
     * The shown badges list
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge badge = 9
     */
    badge: ExpertCard_ExpertCardAttributes_Badge[];
    /**
     * Notable clients names
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient notable_client = 10
     */
    notableClient: ExpertCard_ExpertCardAttributes_NotableClient[];
    /**
     * The price in USD
     *
     * @generated from protobuf field: double price_usd = 11
     */
    priceUsd: number;
    /**
     * The shown price
     *
     * @generated from protobuf field: double shown_price = 12
     */
    shownPrice: number;
    /**
     * Search engine of the first gig in the card
     *
     * @generated from protobuf field: string engine = 13
     */
    engine: string;
    /**
     * price type, per hour or per project
     *
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.PriceType price_type = 14
     */
    priceType?: PriceType;
    /**
     * Auction information for ads
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction auction = 15
     */
    auction?: ExpertCard_ExpertCardAttributes_Auction;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise
 */
export interface ExpertCard_ExpertCardAttributes_Expertise {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bianka.enums.expert_card.ExpertiseType type = 2
     */
    type: ExpertiseType;
    /**
     * @generated from protobuf field: int32 position = 3
     */
    position: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight
 */
export interface ExpertCard_ExpertCardAttributes_Highlight {
    /**
     * @generated from protobuf field: bianka.enums.expert_card.HighlightType type = 1
     */
    type: HighlightType;
    /**
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData parameters = 2
     */
    parameters: ExpertCard_ExpertCardAttributes_HighlightData[];
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller
 */
export interface ExpertCard_ExpertCardAttributes_Seller {
    /**
     * @generated from protobuf field: string title = 2
     */
    title: string;
    /**
     * @generated from protobuf field: bool is_pro = 3
     */
    isPro: boolean;
    /**
     * @generated from protobuf field: bianka.enums.listing.SellerLevel level = 4
     */
    level: SellerLevel;
    /**
     * @generated from protobuf field: string location = 5
     */
    location: string;
    /**
     * @generated from protobuf field: string username = 6
     */
    username: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData
 */
export interface ExpertCard_ExpertCardAttributes_HighlightData {
    /**
     * @generated from protobuf field: string parameter_name = 1
     */
    parameterName: string;
    /**
     * @generated from protobuf field: string parameter_value = 2
     */
    parameterValue: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge
 */
export interface ExpertCard_ExpertCardAttributes_Badge {
    /**
     * @generated from protobuf field: bianka.enums.gig.Badge name = 1
     */
    name: Badge;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient
 */
export interface ExpertCard_ExpertCardAttributes_NotableClient {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction
 */
export interface ExpertCard_ExpertCardAttributes_Auction {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf enum bianka.event.activity.v2.extension.PriceType
 */
export enum PriceType {
    /**
     * @generated from protobuf enum value: PRICE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PRICE_TYPE_PER_PROJECT = 1;
     */
    PER_PROJECT = 1,
    /**
     * @generated from protobuf enum value: PRICE_TYPE_PER_HOUR = 2;
     */
    PER_HOUR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard$Type extends MessageType<ExpertCard> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard", [
            { no: 1, name: "expert_card_attributes", kind: "message", T: () => ExpertCard_ExpertCardAttributes },
            { no: 2, name: "seller", kind: "message", T: () => Seller },
            { no: 3, name: "gig", kind: "message", T: () => Gig }
        ]);
    }
    create(value?: PartialMessage<ExpertCard>): ExpertCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExpertCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard): ExpertCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes expert_card_attributes */ 1:
                    message.expertCardAttributes = ExpertCard_ExpertCardAttributes.internalBinaryRead(reader, reader.uint32(), options, message.expertCardAttributes);
                    break;
                case /* bianka.entities.Seller seller */ 2:
                    message.seller = Seller.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                case /* bianka.entities.Gig gig */ 3:
                    message.gig = Gig.internalBinaryRead(reader, reader.uint32(), options, message.gig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes expert_card_attributes = 1; */
        if (message.expertCardAttributes)
            ExpertCard_ExpertCardAttributes.internalBinaryWrite(message.expertCardAttributes, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bianka.entities.Seller seller = 2; */
        if (message.seller)
            Seller.internalBinaryWrite(message.seller, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bianka.entities.Gig gig = 3; */
        if (message.gig)
            Gig.internalBinaryWrite(message.gig, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard
 */
export const ExpertCard = new ExpertCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes$Type extends MessageType<ExpertCard_ExpertCardAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes", [
            { no: 1, name: "shown_seller_rating", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "completed_orders", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "is_online", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "expertise", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExpertCard_ExpertCardAttributes_Expertise },
            { no: 6, name: "highlights", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExpertCard_ExpertCardAttributes_Highlight },
            { no: 7, name: "seller", kind: "message", T: () => ExpertCard_ExpertCardAttributes_Seller },
            { no: 9, name: "badge", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExpertCard_ExpertCardAttributes_Badge },
            { no: 10, name: "notable_client", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExpertCard_ExpertCardAttributes_NotableClient },
            { no: 11, name: "price_usd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "shown_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "engine", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "price_type", kind: "enum", opt: true, T: () => ["bianka.event.activity.v2.extension.PriceType", PriceType, "PRICE_TYPE_"] },
            { no: 15, name: "auction", kind: "message", T: () => ExpertCard_ExpertCardAttributes_Auction }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes>): ExpertCard_ExpertCardAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shownSellerRating = 0;
        message.completedOrders = 0;
        message.isOnline = false;
        message.expertise = [];
        message.highlights = [];
        message.badge = [];
        message.notableClient = [];
        message.priceUsd = 0;
        message.shownPrice = 0;
        message.engine = "";
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes): ExpertCard_ExpertCardAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double shown_seller_rating */ 1:
                    message.shownSellerRating = reader.double();
                    break;
                case /* int32 completed_orders */ 2:
                    message.completedOrders = reader.int32();
                    break;
                case /* bool is_online */ 3:
                    message.isOnline = reader.bool();
                    break;
                case /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise expertise */ 5:
                    message.expertise.push(ExpertCard_ExpertCardAttributes_Expertise.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight highlights */ 6:
                    message.highlights.push(ExpertCard_ExpertCardAttributes_Highlight.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller seller */ 7:
                    message.seller = ExpertCard_ExpertCardAttributes_Seller.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                case /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge badge */ 9:
                    message.badge.push(ExpertCard_ExpertCardAttributes_Badge.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient notable_client */ 10:
                    message.notableClient.push(ExpertCard_ExpertCardAttributes_NotableClient.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* double price_usd */ 11:
                    message.priceUsd = reader.double();
                    break;
                case /* double shown_price */ 12:
                    message.shownPrice = reader.double();
                    break;
                case /* string engine */ 13:
                    message.engine = reader.string();
                    break;
                case /* optional bianka.event.activity.v2.extension.PriceType price_type */ 14:
                    message.priceType = reader.int32();
                    break;
                case /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction auction */ 15:
                    message.auction = ExpertCard_ExpertCardAttributes_Auction.internalBinaryRead(reader, reader.uint32(), options, message.auction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double shown_seller_rating = 1; */
        if (message.shownSellerRating !== 0)
            writer.tag(1, WireType.Bit64).double(message.shownSellerRating);
        /* int32 completed_orders = 2; */
        if (message.completedOrders !== 0)
            writer.tag(2, WireType.Varint).int32(message.completedOrders);
        /* bool is_online = 3; */
        if (message.isOnline !== false)
            writer.tag(3, WireType.Varint).bool(message.isOnline);
        /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise expertise = 5; */
        for (let i = 0; i < message.expertise.length; i++)
            ExpertCard_ExpertCardAttributes_Expertise.internalBinaryWrite(message.expertise[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight highlights = 6; */
        for (let i = 0; i < message.highlights.length; i++)
            ExpertCard_ExpertCardAttributes_Highlight.internalBinaryWrite(message.highlights[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller seller = 7; */
        if (message.seller)
            ExpertCard_ExpertCardAttributes_Seller.internalBinaryWrite(message.seller, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge badge = 9; */
        for (let i = 0; i < message.badge.length; i++)
            ExpertCard_ExpertCardAttributes_Badge.internalBinaryWrite(message.badge[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient notable_client = 10; */
        for (let i = 0; i < message.notableClient.length; i++)
            ExpertCard_ExpertCardAttributes_NotableClient.internalBinaryWrite(message.notableClient[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* double price_usd = 11; */
        if (message.priceUsd !== 0)
            writer.tag(11, WireType.Bit64).double(message.priceUsd);
        /* double shown_price = 12; */
        if (message.shownPrice !== 0)
            writer.tag(12, WireType.Bit64).double(message.shownPrice);
        /* string engine = 13; */
        if (message.engine !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.engine);
        /* optional bianka.event.activity.v2.extension.PriceType price_type = 14; */
        if (message.priceType !== undefined)
            writer.tag(14, WireType.Varint).int32(message.priceType);
        /* bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction auction = 15; */
        if (message.auction)
            ExpertCard_ExpertCardAttributes_Auction.internalBinaryWrite(message.auction, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes
 */
export const ExpertCard_ExpertCardAttributes = new ExpertCard_ExpertCardAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_Expertise$Type extends MessageType<ExpertCard_ExpertCardAttributes_Expertise> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.enums.expert_card.ExpertiseType", ExpertiseType, "EXPERTISE_TYPE_"] },
            { no: 3, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_Expertise>): ExpertCard_ExpertCardAttributes_Expertise {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_Expertise>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_Expertise): ExpertCard_ExpertCardAttributes_Expertise {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bianka.enums.expert_card.ExpertiseType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* int32 position */ 3:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_Expertise, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bianka.enums.expert_card.ExpertiseType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* int32 position = 3; */
        if (message.position !== 0)
            writer.tag(3, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Expertise
 */
export const ExpertCard_ExpertCardAttributes_Expertise = new ExpertCard_ExpertCardAttributes_Expertise$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_Highlight$Type extends MessageType<ExpertCard_ExpertCardAttributes_Highlight> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight", [
            { no: 1, name: "type", kind: "enum", T: () => ["bianka.enums.expert_card.HighlightType", HighlightType, "HIGHLIGHT_TYPE_"] },
            { no: 2, name: "parameters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExpertCard_ExpertCardAttributes_HighlightData }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_Highlight>): ExpertCard_ExpertCardAttributes_Highlight {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.parameters = [];
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_Highlight>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_Highlight): ExpertCard_ExpertCardAttributes_Highlight {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.enums.expert_card.HighlightType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData parameters */ 2:
                    message.parameters.push(ExpertCard_ExpertCardAttributes_HighlightData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_Highlight, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.enums.expert_card.HighlightType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* repeated bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData parameters = 2; */
        for (let i = 0; i < message.parameters.length; i++)
            ExpertCard_ExpertCardAttributes_HighlightData.internalBinaryWrite(message.parameters[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Highlight
 */
export const ExpertCard_ExpertCardAttributes_Highlight = new ExpertCard_ExpertCardAttributes_Highlight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_Seller$Type extends MessageType<ExpertCard_ExpertCardAttributes_Seller> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller", [
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_pro", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "level", kind: "enum", T: () => ["bianka.enums.listing.SellerLevel", SellerLevel, "SELLER_LEVEL_"] },
            { no: 5, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_Seller>): ExpertCard_ExpertCardAttributes_Seller {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.isPro = false;
        message.level = 0;
        message.location = "";
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_Seller>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_Seller): ExpertCard_ExpertCardAttributes_Seller {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* bool is_pro */ 3:
                    message.isPro = reader.bool();
                    break;
                case /* bianka.enums.listing.SellerLevel level */ 4:
                    message.level = reader.int32();
                    break;
                case /* string location */ 5:
                    message.location = reader.string();
                    break;
                case /* string username */ 6:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_Seller, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* bool is_pro = 3; */
        if (message.isPro !== false)
            writer.tag(3, WireType.Varint).bool(message.isPro);
        /* bianka.enums.listing.SellerLevel level = 4; */
        if (message.level !== 0)
            writer.tag(4, WireType.Varint).int32(message.level);
        /* string location = 5; */
        if (message.location !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.location);
        /* string username = 6; */
        if (message.username !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Seller
 */
export const ExpertCard_ExpertCardAttributes_Seller = new ExpertCard_ExpertCardAttributes_Seller$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_HighlightData$Type extends MessageType<ExpertCard_ExpertCardAttributes_HighlightData> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData", [
            { no: 1, name: "parameter_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parameter_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_HighlightData>): ExpertCard_ExpertCardAttributes_HighlightData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.parameterName = "";
        message.parameterValue = "";
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_HighlightData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_HighlightData): ExpertCard_ExpertCardAttributes_HighlightData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string parameter_name */ 1:
                    message.parameterName = reader.string();
                    break;
                case /* string parameter_value */ 2:
                    message.parameterValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_HighlightData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string parameter_name = 1; */
        if (message.parameterName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.parameterName);
        /* string parameter_value = 2; */
        if (message.parameterValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.parameterValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.HighlightData
 */
export const ExpertCard_ExpertCardAttributes_HighlightData = new ExpertCard_ExpertCardAttributes_HighlightData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_Badge$Type extends MessageType<ExpertCard_ExpertCardAttributes_Badge> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge", [
            { no: 1, name: "name", kind: "enum", T: () => ["bianka.enums.gig.Badge", Badge, "BADGE_"] }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_Badge>): ExpertCard_ExpertCardAttributes_Badge {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = 0;
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_Badge>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_Badge): ExpertCard_ExpertCardAttributes_Badge {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.enums.gig.Badge name */ 1:
                    message.name = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_Badge, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.enums.gig.Badge name = 1; */
        if (message.name !== 0)
            writer.tag(1, WireType.Varint).int32(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Badge
 */
export const ExpertCard_ExpertCardAttributes_Badge = new ExpertCard_ExpertCardAttributes_Badge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_NotableClient$Type extends MessageType<ExpertCard_ExpertCardAttributes_NotableClient> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_NotableClient>): ExpertCard_ExpertCardAttributes_NotableClient {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_NotableClient>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_NotableClient): ExpertCard_ExpertCardAttributes_NotableClient {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_NotableClient, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.NotableClient
 */
export const ExpertCard_ExpertCardAttributes_NotableClient = new ExpertCard_ExpertCardAttributes_NotableClient$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpertCard_ExpertCardAttributes_Auction$Type extends MessageType<ExpertCard_ExpertCardAttributes_Auction> {
    constructor() {
        super("bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExpertCard_ExpertCardAttributes_Auction>): ExpertCard_ExpertCardAttributes_Auction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ExpertCard_ExpertCardAttributes_Auction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExpertCard_ExpertCardAttributes_Auction): ExpertCard_ExpertCardAttributes_Auction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExpertCard_ExpertCardAttributes_Auction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ExpertCard.ExpertCardAttributes.Auction
 */
export const ExpertCard_ExpertCardAttributes_Auction = new ExpertCard_ExpertCardAttributes_Auction$Type();
